import { render } from "./MainBanner.vue?vue&type=template&id=5302a10f&scoped=true"
const script = {}

import "./MainBanner.vue?vue&type=style&index=0&id=5302a10f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5302a10f"]])

export default __exports__